module.exports = __webpack_public_path__ + "static/media/38.44c39f4e.png";